import React, {CSSProperties, FC} from "react";
import {Box, makeStyles} from "@material-ui/core";

interface Props {
  className?: string;
  delay?: number;
  delayIndex?: number;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  style?: CSSProperties;
}

const FadeInBox: FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <Box
      style={{
        ...(props.style || {}),
        animationDelay: `${
          (props.delayIndex || 0) * (props.delay ?? DEFAULT_DELAY)
        }ms`,
      }}
      className={`${classes.root} ${props.className}`}
      onClick={props.onClick}
    >
      {props.children}
    </Box>
  );
};

export default FadeInBox;

const DEFAULT_DELAY = 400;

const useStyles = makeStyles({
  root: {
    opacity: 0,
    animation: `$fadeInBox ${DEFAULT_DELAY}ms 1`,
    transform: "scale(0.95)",
    animationFillMode: "forwards",
  },
  "@keyframes fadeInBox": {
    from: { opacity: 0, transform: "scale(0.95)" },
    to: { opacity: 1, transform: "scale(1)" },
  },
});
